import { IsNotEmpty } from 'class-validator';

import PasswordValidator from './PasswordValidator';
import { ERROR_MESSAGE } from './constants';

class PasswordSettingValidator extends PasswordValidator {
  @IsNotEmpty({ message: ERROR_MESSAGE.UNCONFIRMED_PASSWORD() })
  currentPassword: string;
}

export default PasswordSettingValidator;
